export const DATA_LAYER_EVENT_NAMES = {
  addToCart: 'add_to_cart',
  checkoutStart: 'checkout_start',
  checkoutReview: 'checkout_review',
  orderConfirmClick: 'order_confirm_click',
  purchaseSuccess: 'purchase_success',
} as const;

export type DataLayerEventName = typeof DATA_LAYER_EVENT_NAMES[keyof typeof DATA_LAYER_EVENT_NAMES];

export type DataLayerItem = {
  item_id: string;
  item_name: string;
  item_category?: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
};

export type DataLayerEcommercePayload = {
  currency: 'EUR';
  value: number;
  items: DataLayerItem[];
};

type DataLayerEntry = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEntry[];
  }
}

/**
 * pushDataLayerEvent
 *
 * Sends app-owned checkout milestones to Google Tag Manager. GTM initializes
 * the same global array, but this guard keeps the ordering flow observable even
 * if the app code runs before the GTM script has finished loading.
 */
export const pushDataLayerEvent = (
  eventName: DataLayerEventName,
  ecommercePayload?: DataLayerEcommercePayload,
): DataLayerEntry => {
  window.dataLayer = window.dataLayer ?? [];

  const dataLayerEntry: DataLayerEntry = ecommercePayload
    ? { event: eventName, ecommerce: ecommercePayload }
    : { event: eventName };

  window.dataLayer.push(dataLayerEntry);

  return dataLayerEntry;
};
